export enum PlayerState {
	Playing = "playing",
	Paused = "paused",
	Stopped = "stopped",
}
